<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrKontrolStandart from "@/models/StrKontrolStandart";
import AddEdit from "./AddEdit.vue";
export default {
  mixins: [Api, Sabit, StrKontrolStandart],
  page: {
    title: "Standartlar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("StrKontrolStandart.Title"),
      items: [
        {
          text: this.$t("StrKontrolStandart.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrKontrolStandart.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrKontrolStandart.Title"),
          active: true,
        },
      ],
      AnaGrupIdVerileri: [],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      siralama:"&Asc=SiraNo",
    };
  },

  methods: {
    Get() {
         
         let Filter="";

         if(this.siralama!=null && this.siralama!=""){
             Filter=Filter+this.siralama;
          }

      this.ActionsFilterGet({ Service: "StrKontrolStandart", Page: this.Page, Filter: Filter }).then((res) => {
    
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrKontrolStandart @click="(DataUpdate = StrKontrolStandartData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i> {{ $t("StrKontrolStandart.Page.YeniKayitEkle") }}</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("StrKontrolStandart.Table.SiraNo") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=SiraNo'" @click="siralama='&Asc=SiraNo', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=SiraNo'" @click="siralama='&Desc=SiraNo', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                      <th>{{ $t("StrKontrolStandart.Table.StandartKodNo") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=StandartKodNo'" @click="siralama='&Asc=StandartKodNo', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=StandartKodNo'" @click="siralama='&Desc=StandartKodNo', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                      <th>{{ $t("StrKontrolStandart.Table.StandartGenelSarti") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=StandartGenelSarti'" @click="siralama='&Asc=StandartGenelSarti', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=StandartGenelSarti'" @click="siralama='&Desc=StandartGenelSarti', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                      <th>{{ $t("StrKontrolStandart.Table.AnaGrupValue") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=AnaGrupValue'" @click="siralama='&Asc=AnaGrupValue', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=AnaGrupValue'" @click="siralama='&Desc=AnaGrupValue', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                             <th>{{ $t("StrKontrolStandart.Table.Aciklama") }}
                      <th style="width: 85px; text-align: center; vertical-align: middle;">{{ $t("StrKontrolStandart.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="TableDataVerileri in TableData" :key="TableDataVerileri.Id">
                      <th scope="row">{{ TableDataVerileri.SiraNo }}</th>
                      <td>{{ TableDataVerileri.StandartKodNo }}</td>
                      <td>{{ TableDataVerileri.StandartGenelSarti }}</td>
                      <td>{{ TableDataVerileri.AnaGrupValue }}</td>
                                            <td>{{ TableDataVerileri.Aciklama }}</td>
                      <td style="width: 85px; text-align: center; vertical-align: middle;">
                        <b-button-group>
                          <b-button variant="primary" v-b-modal.StrKontrolStandart @click="(DataUpdate = TableDataVerileri), (AddEdit = 'Edit')"><i class="fas fa-pencil-alt"></i></b-button>
                          <b-button variant="danger" @click="Delete('StrKontrolStandart', TableDataVerileri.Id)"><i class="fas fa-trash-alt"></i></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" />
    </Layout>
  </Loader>
</template>
